import ReactModal from "react-modal";

import styles from "./StatusModal.module.css";
import type { ReactElement, ReactNode } from "react";
import Icon from "../Icon/Icon";

type StatusModalPropsType = {
  isOpen: boolean;
  icon?: ReactElement;
  onRequestClose: () => void;
  children: ReactNode;
};

const StatusModal = ({
  isOpen,
  onRequestClose,
  children,
  icon,
}: StatusModalPropsType) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={styles.modal}
      overlayClassName={styles.overlay}
      ariaHideApp={false}
    >
      {icon ? (
        icon
      ) : (
        <div className={styles.statusIconContainer}>
          <Icon name="checkmark" size={40} className={styles.statusIcon} />
        </div>
      )}

      {children}

      <button className={styles.closeIcon} onClick={onRequestClose}>
        <Icon name="x-mark" size={16} />
      </button>
    </ReactModal>
  );
};

export default StatusModal;
